<template>
  <modal
    v-if="assessments.length"
    v-bind="$attrs"
    v-on="$listeners"
    :title="title"
    :errors="{}"
    :class="!this.isSpecialAssessmentTest ? 'assessments-normal' : 'assessments-addition-score'"
  >
    <template v-slot:header>
    </template>
    <template v-slot:body>
      <el-table
        v-if="assessments.length > 0 && !isSpecialAssessmentTest"
        :data="assessments"
        class="assessment-history"
        header-row-class-name="assessment-header"
        :empty-text="$t('common.no_values')"
      >
        <base-table-column
          sortable
          prop="skills"
          align="center"
          type="expand"
          :fields="[
            {prop: 'name', label: $t('classes.classes_details.students_section.skill_name')},
            {prop: 'score', label: $t('classes.classes_details.students_section.skill_score'), format_score: (val) => Math.round(val)}
          ]"
        />
        <base-table-column
          sortable
          prop="assessment_test_eps"
          align="center"
          :formatter="percentageFormatter"
          :label="$t('classes.classes_details.students_section.assessment_test')"
        />
        <base-table-column
          sortable
          prop="ons"
          align="center"
          :formatter="percentageFormatter"
          :label="$t('classes.classes_details.students_section.pronunciation')"
        />
        <base-table-column
          sortable
          prop="sis"
          align="center"
          :formatter="percentageFormatter"
          :label="$t('classes.classes_details.students_section.intonation')"
        />
        <base-table-column
          sortable
          prop="fls"
          align="center"
          :formatter="percentageFormatter"
          :label="$t('classes.classes_details.students_section.fluency')"
        />
        <base-table-column
          sortable
          dataType="date"
          prop="date_assessment"
          align="center"
          dateFormat="HH:mma, MM/dd/yyyy"
          :label="$t('classes.classes_details.students_section.date_take_assessment')"
        />
      </el-table>
      <el-table
        v-else
        :data="assessments"
        class="assessment-history"
        header-row-class-name="assessment-header"
        :empty-text="$t('common.no_values')"
      >
        <base-table-column
          sortable
          prop="overall"
          align="center"
          :label="$t('classes.classes_details.students_section.assessment_test')"
        />
        <base-table-column
          sortable
          prop="pronunciation"
          align="center"
          :label="$t('classes.classes_details.students_section.pronunciation')"
        />
        <base-table-column
          sortable
          prop="intonation"
          align="center"
          :label="$t('classes.classes_details.students_section.intonation')"
        />
        <base-table-column
          sortable
          prop="word_linkage"
          align="center"
          :label="$t('classes.classes_details.students_section.word_linkage')"
        />
        <base-table-column
          sortable
          prop="ending_sounds"
          align="center"
          :label="$t('classes.classes_details.students_section.ending_sounds')"
        />
        <base-table-column
          sortable
          prop="pausing"
          align="center"
          :label="$t('classes.classes_details.students_section.pausing')"
        />
        <base-table-column
          sortable
          prop="pace"
          align="center"
          :label="$t('classes.classes_details.students_section.pace')"
        />
        <base-table-column
          sortable
          prop="text"
          align="center"
          :label="$t('classes.classes_details.students_section.text')"
        />
        <base-table-column
          sortable
          prop="volume"
          align="center"
          :label="$t('classes.classes_details.students_section.volume')"
        />
        <base-table-column
          sortable
          dataType="date"
          prop="date_assessment"
          align="center"
          dateFormat="HH:mma, MM/dd/yyyy"
          :label="$t('classes.classes_details.students_section.date_take_assessment')"
        />
      </el-table>
      <div class="actions">
        <primary-button
          @click.native="closeModal"
        >
          OK
        </primary-button>
      </div>
    </template>
  </modal>
</template>

<script>
  import Modal from '@/components/common/Modal'
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import percentage from '@/components/common/mixins/percentage'
  import {unless, isNil } from 'ramda'
  import BaseTableColumn from '@/components/classes/BaseTableColumn'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      Modal,
      PrimaryButton,
      BaseTableColumn,
    },
    props: {
      assessments: {
        type: Array,
      },
      assessmentType: {
        type: String
      },
      title: {
        type: String
      },
    },
    computed: {
      ...mapGetters({
        currentOrganization: 'organization/currentOrganization'
      }),
      isSpecialAssessmentTest() {
        return this.assessmentType=='sgd-assessment'
      },
    },
    methods: {
      closeModal() {
        this.$emit('closed')
      },
      percentageFormatter(row, column, cellValue, index) {
        if(cellValue == 0) return null;
        return percentage.filters.toPercentage(unless(isNil, Math.round)(cellValue));
      },
    }
  }
</script>

<style lang="scss" scoped>
.assessment-history {
  padding-bottom: 10px !important;
}
.actions {
  align-items: flex-start;
  .el-button {
    padding: 12px;
  }
}
.assessments-normal {
  ::v-deep .el-dialog.elsa-modal {
    width: 70%;
  }
}
.assessments-addition-score {
  ::v-deep .el-dialog.elsa-modal {
    width: 95%;
  }
}

</style>
